import { NavLink } from 'react-router-dom';
import { useMemo, useEffect} from 'react';
import { ReactComponent as ForwardIcon } from '../../images/icons/forward.svg';
import { useLabOrderDetailsStore, useProductSelectionStore } from '../../stores';

const LabOrderDetailsNav = ({currentOrderId}) => {
  const setProductType = useProductSelectionStore((state) => state.setProductType);
  const setCartCount = useProductSelectionStore((state) => state.setCartCount);
  
  const {
    order,
    orderStatus,
    setOrderStatus,
    setTrackingUrl,
    calculateOrderProgress,
  } = useLabOrderDetailsStore();

  const lineItemStatusArray = useMemo(() => {
    return order?.included?.map(item => item.attributes?.status) ?? null;
  }, [order]);

  const currentOrder = useMemo(() => {
    if (order?.data?.attributes?.guid === currentOrderId) return order?.data; 
    return null;
  }, [order, currentOrderId]);

  const isOpen = orderStatus === 'open';

  // Sync order status and tracking URL from currentOrder to store
  useEffect(() => {
    if (currentOrder?.attributes?.status) {
      setOrderStatus(currentOrder.attributes.status);
    }
  }, [currentOrder?.attributes?.status, setOrderStatus]);

  useEffect(() => {
    if (currentOrder?.attributes?.trackingUrl) {
      setTrackingUrl(currentOrder.attributes.trackingUrl);
    }
  }, [currentOrder?.attributes?.trackingUrl, setTrackingUrl]);

  // Calculate order progress when line items or order status changes
  useEffect(() => {
    if (lineItemStatusArray && currentOrder) {
      calculateOrderProgress(lineItemStatusArray, currentOrder);
    }
  }, [lineItemStatusArray, currentOrder, calculateOrderProgress]);

  if (!isOpen) return null;

  return (
    <div className="container-topbar-orders">
      <div className="grid-topbar-orders">
        <div className="sub-grid-topbar-orders">
          {/* Buttons */}
          <div className="w-layout-grid grid-button-topbar-orders">

            {isOpen && (
              <NavLink
                to={`/product-selection/${currentOrderId}`}
                state={{ cartCount: order?.included?.length ?? 0 }}
                className="_2nd-button secondary w-inline-block"
                onClick={() => {
                  setProductType('default');
                  setCartCount(order?.included?.length ?? 0);
                }}
              >
                <div className="icon right-margin w-embed"><ForwardIcon /></div>
                <div>Continue Order</div>
              </NavLink>
            )}

          </div>
        </div>
      </div >
    </div>
  );
};

export default LabOrderDetailsNav;
